import { waitForPendingWrites } from "@/features/storage/pendingWrites";

import { PENDING_WRITES_FLUSH_TIMEOUT_MS } from "../constants";

const wait = (durationMs: number): Promise<void> => {
  return new Promise((resolve) => {
    setTimeout(resolve, durationMs);
  });
};

export const reloadApplication = async (): Promise<void> => {
  await Promise.race([waitForPendingWrites(), wait(PENDING_WRITES_FLUSH_TIMEOUT_MS)]);
  window.location.reload();
};
